'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pill = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Group = require('./components/Group');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Pill = function Pill(_ref) {
  var text = _ref.text,
      image = _ref.image,
      selected = _ref.selected,
      className = _ref.className,
      children = _ref.children,
      _onClick = _ref.onClick,
      props = (0, _objectWithoutProperties3.default)(_ref, ['text', 'image', 'selected', 'className', 'children', 'onClick']);

  return _react2.default.createElement('button', (0, _extends3.default)({
    className: (0, _classnames2.default)('pill-Button', {
      'pill-Button-selected': selected,
      'pill-Button_Bg-color': window.theme.isBrandedHouse
    }),
    onClick: function onClick() {
      return _onClick();
    }
  }, props), image && _react2.default.createElement('img', { className: 'pill-Button_Image', src: image, alt: text }), _react2.default.createElement('span', { className: 'pill-Button_Text' }, text));
};

exports.Pill = Pill;
Pill.defaultProps = {
  className: undefined,
  onClick: function onClick() {
    return null;
  }
};

Pill.propTypes = {
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};

Pill.Group = _Group.Group;